import axios from "axios";
import "../helpers/axios";
import { Event } from "../model/event";

const API_BASE_URL = process.env.REACT_APP_API_URL ?? "";

const buildUrl = (path: string): string => `${API_BASE_URL}${path}`;

type EventListEnvelope = {
  events?: Event[];
  data?: Event[];
  lastKey?: string;
};

export interface ListEventsResult {
  events: Event[];
  lastKey?: string;
}

export const listEvents = async (): Promise<ListEventsResult> => {
  const response = await axios.get<EventListEnvelope>(buildUrl("/events"));
  const payload = response.data;

  return {
    events: Array.isArray(payload.events)
      ? payload.events
      : Array.isArray(payload.data)
        ? payload.data
        : [],
    lastKey: payload.lastKey,
  };
};
